(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["db-back-in-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('db-back-in-stock')) {
    customElements.define('db-back-in-stock', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.hidden = this.dataset.eligible !== 'true';
        this.querySelector('[data-db-bis-open]').addEventListener('click', () => this.open(), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.dialog?.remove();
        this.dialog = null;
      }

      currentVariantMatches() {
        const form = document.getElementById(this.dataset.form);
        return form?.elements.namedItem('id')?.value === this.dataset.variant && this.dataset.eligible === 'true';
      }

      open() {
        if (!this.currentVariantMatches()) return;
        if (!this.dialog) {
          this.dialog = this.querySelector('template').content.firstElementChild.cloneNode(true);
          document.body.append(this.dialog);
          const options = { signal: this.controller.signal };
          this.dialog.querySelector('[data-db-bis-close]').addEventListener('click', () => this.dialog.close(), options);
          this.dialog.addEventListener('click', event => {
            if (event.target !== this.dialog) return;
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
          }, options);
          this.dialog.querySelector('form').addEventListener('submit', event => this.submit(event), options);
          this.dialog.addEventListener('close', () => this.querySelector('[data-db-bis-open]')?.focus(), options);
        }
        this.dialog.showModal();
        this.dialog.querySelector('input').focus();
      }

      message(name) {
        this.dialog.querySelector('.db-bis__status').textContent = this.dialog.querySelector('[data-message-' + name + ']').textContent;
      }

      async post(resource, data) {
        const response = await fetch('https://a.klaviyo.com/client/' + resource + '/?company_id=' + encodeURIComponent(this.dataset.company), {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify({ data }),
          signal: AbortSignal.timeout(15000)
        });
        if (response.status !== 202) throw new Error('Subscription request failed');
      }

      async submit(event) {
        event.preventDefault();
        if (this.pending) return;
        const input = event.target.elements.namedItem('email');
        input.value = input.value.trim();
        if (!input.checkValidity()) {
          this.message('invalid');
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        if (!this.currentVariantMatches()) { this.message('changed'); return; }
        if (this.dataset.mode !== 'active') { this.message('preview'); return; }
        this.pending = true;
        const submit = event.target.querySelector('[type="submit"]');
        submit.disabled = true;
        event.target.setAttribute('aria-busy', 'true');
        const email = input.value;
        const variant = this.dataset.variant;
        const language = this.dataset.language.split('-')[0];
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('variant', variant);
        try {
          await this.post('profiles', {
            type: 'profile',
            attributes: {
              email,
              properties: {
                [variant + '_db_bis']: {
                  language: ['de', 'en', 'fr'].includes(language) ? language : 'en',
                  subject: this.dataset.emailSubject,
                  preview: this.dataset.emailPreview,
                  url: url.href,
                  title: this.dataset.title,
                  variant_title: this.dataset.variantTitle,
                  requested_at: new Date().toISOString(),
                  source: 'DRAKENSBERG PDP'
                }
              }
            }
          });
          await this.post('back-in-stock-subscriptions', {
            type: 'back-in-stock-subscription',
            attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } }
          });
          if (this.dialog) {
            this.message('success');
            input.disabled = true;
            this.dialog.querySelector('.db-bis__status').focus();
          }
        } catch {
          if (this.dialog) { this.message('error'); submit.disabled = false; }
        } finally {
          this.pending = false;
          event.target.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
